export enum LossLimitComputeType {
    // Uses the balance at autospin start, then compares it with the current balance, in order to compute the loss.
    BalanceBased,
    // Ignores the balance (because when more than 1 game is played by using the same user account, the balance is unreliable),
    // but directly accumulates (subtracts the bets and adds the wins) the profit on each spin.
    NonBalanceBased
}